<template>
  <div class="areaCountry">
    <div class="header">
      <div class="inner">
        <div class="select">
          <select v-model="selectedCountry">
            <option
              v-for="item in AreaCountryList[areaId].countries"
              :key="item.country_id"
              :value="item.country_id"
            >
              {{ item.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="worldCategory">
      <div class="category">
        <p class="category__title">
          {{ areaLabelMap[areaId] }}
        </p>
        <div class="category__content">
          <p
            v-for="item in AreaCountryList[areaId].countries"
            :key="item.country_id"
            :data-category="item.country_id"
            :data-selected="selectedCountry === item.country_id"
            class="category__text"
            @click="selectedCountry = item.country_id"
          >
            {{ item.label }}
          </p>
        </div>
      </div>
      <div class="list">
        <template
          v-for="item in AreaCountryList[areaId].points[selectedCountry]"
          :key="item.point_id"
        >
          <NuxtLink
            :to="isExternalLink ? `${runtimeConfig.app.baseURL}${item.point_id.replace(/^\//, '')}` : item.point_id"
            :external="isExternalLink"
            class="link"
          >{{ item.label }}<span
            class="note"
          >（{{ item.country_ja }}）</span></NuxtLink>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import AreaCountryList from '~/data/table/area_country_list.json'

defineProps({
  areaId: {
    type: String,
    required: true
  }
})

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)

const selectedCountry = ref('all')
</script>

<style lang="scss" scoped>
.areaCountry{
  display: flex;
  flex-direction: column;
  gap: 10px;
  .header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .inner {
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 10px;
    }
    .select {
      border-radius: 4px;
      background-color: #EEF1F8;
      color: #000;
      font-size: 14px;
      line-height: 1em;
      background-image: url('~/assets/images/common/icon_arrow_bottom.svg');
      background-size: 11px;
      background-repeat: no-repeat;
      background-position: right 5px center;
      select {
        padding: 5px 35px 5px 5px;
        outline: none;
        cursor: pointer;
      }
    }
  }

  .worldCategory {
    display: flex;
    align-items: flex-start;
    gap: 25px;
    .category {
      display: none;
      flex-direction: column;
      width: 182px;
      border: 1px solid #CCC;
      &__title {
        text-align: center;
        padding-block: 10px;
        background-color: #EEF1F8;
        border-bottom: 1px solid #CCC;
        color: #101010;
        font-size: 15px;
        font-weight: 600;
        line-height: 1em;
      }
      &__content {
        display: flex;
        flex-direction: column;
        gap: 5px;
        max-height: 418px;
        overflow-y: scroll;
        padding: 10px 4px 10px 10px;
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 100vmax;
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 6px;
          background: #438fec;
        }
      }
      &__text {
        padding: 5px;
        color: #3569C0;
        font-size: 15px;
        font-weight: 600;
        line-height: 22px;
        border-bottom: solid 1px #ccc;
        cursor: pointer;
        &[data-selected='true'] {
          color: #303030;
          background-color: #EEF1F8;
          border-bottom: none;
          pointer-events: none;
        }
      }
    }
    .list {
      display: flex;
      flex: 1;
      flex-direction: column;
      max-height: calc(10.5 * 32.5px);
      overflow-y: scroll;
      border: 1px solid #ccc;
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 100vmax;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background: #438fec;
      }
      .link {
        padding: 9px 8px 6px;
        color: #3569C0;
        font-size: 15px;
        font-weight: 600;
        line-height: 1em;
        &:not(:last-child) {
          border-bottom: 1px solid #ccc;
        }
      }
      .note {
        color: #606060;
        font-size: 10px;
        font-weight: 600;
      }
    }
    @media (any-hover: hover) {
      .category {
        &__text {
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
      }
    }
  }
}

.areaCountry{
  @media screen and (min-width: 830px) {
    .header {
      flex-direction: row;
      justify-content: space-between;
      .select {
        display: none;
      }
    }
    .worldCategory {
      .category {
        display: flex;
      }
      .list {
        max-height: 454px;
      }
    }
  }
}
</style>
